import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll';
import { subDays, addDays, parse } from 'date-fns';
import { Alert, Calendar, Label } from '@a-ui/react';

import { ScrollTo } from 'components/Helpers';
import { getAvailableDays } from 'actions/AvailableDays';

import FormNavigation from '../FormNavigation';

const DatePickerStep = ({
  product = {},
  data,
  onChange,
  index,
  mode,
  stepData,
  previous,
  next,
  steps
}) => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  let [error, setError] = useState(null);

  useEffect(() => {
    ScrollTo('top');

    setSelectedDate(stepData);
    dispatch(getAvailableDays(product.id, data.duration.amount, data.locations)).then(({ payload }) => {
      setDates(payload.dates.map(dateString => {
        const [day, month, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }));
    })
  }, []);

  const changeDate = date => {
    setSelectedDate(date);
    onChange('timeslot', {});
  }

  const getUnavailableDays = dates => {
    const startDate = new Date(dates[0]);
    const endDate = new Date(dates[dates.length - 1]);
    const missingDays = [];

    for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
      const currentDateString = currentDate.toISOString().split('T')[0];

      if (!dates.includes(currentDateString)) {
        // Maak een Date object met tijd 00:00
        const dateWithZeroTime = new Date(currentDateString + 'T00:00:00');
        missingDays.push(dateWithZeroTime.toISOString());
      }
    }

    return missingDays;
  }

  const getUnavailableTo = dates => {
    if (dates.length === 0) return;
    const firstDate = dates[0];

    // Parse the date string of the first element in the array
    const firstDateSubstractedOneDay = subDays(parse(firstDate, 'yyyy-MM-dd', new Date()), 1);

    return firstDateSubstractedOneDay;
  };

  const getUnavailableFrom = dates => {
    if (dates.length === 0) return;
    // Get the last date from the array
    const lastDate = dates[dates.length - 1];

    const lastDateAddedOneDay = addDays(parse(lastDate, 'yyyy-MM-dd', new Date()), 1);
    return lastDateAddedOneDay;
  };

  const onValidate = () => {
    if (selectedDate) {
      return true;
    } else {
      setError({
        title: 'Selecteer een datum',
        description: 'Selecteer een datum om verder te gaan.'
      });
      scroll.scrollToTop();
    }
  };

  const goToNextStep = () => {
    if (onValidate()) {
      onChange('date', selectedDate);
      next();
    }
  };

  const renderTitle = () => {
    if (mode === 'kiosk') return null;

    return (
      <div className="u-margin-top u-margin-bottom">
        <h3>Selecteer een datum</h3>
        <p className="u-margin-top">Geen datum die voor jou past? Ga dan terug om andere locaties te kiezen.</p>
      </div>
    );
  };

  return (
    <>
      {mode !== 'kiosk' &&
        <div className="u-margin-top u-margin-bottom title-appointment"><Label
          type="primary"
        >{product.name}
        </Label>
        </div>
      }
      {renderTitle()}
      {error && (
        <Alert theme="danger" inline title={{ label: error.title }}>
          {error.description}
        </Alert>
      )}

      <div className="u-margin-top u-margin-bottom-xl">
        <Calendar
          value={selectedDate}
          unavailable={getUnavailableDays(dates)}
          unavailableFrom={dates.length === 0 ? '1970-01-01' : getUnavailableFrom(dates)}
          unavailableTo={getUnavailableTo(dates)}
          onChange={(date) => changeDate(date)}
        />
      </div>

      <FormNavigation current={index} valid={true} previous={previous} next={goToNextStep} steps={steps} />
    </>
  );
};

export default DatePickerStep;
